module.exports = "<reports-page></reports-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/reports.html
// module id = 1614
// module chunks = 0